import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import ShopLayout from "../Layout";
import ProductOutOfStockList from "../../../components/Product/out-of-stock";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import BreadCrumb from "../../Layouts/Breadcrumb";
import { Avatar, Button, Drawer, Empty, Pagination, Switch } from "antd";
import { getPage, getParamValue } from "../../../utils";
import axios from "axios";
import moment from "moment";
import { responseNotification } from "../../../utils/notify";
import { AddBtn, Loader } from "../../common";
import AddAddOns from "./AddAddOns";
import SingleAddOns from "./AddOnsDetails";
import styles from "../../../styles/tailwind/List.module.css";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";

const ShopAddonsList = (): ReactElement => {
    const { type, token } = useSelector((state) => (state as any)?.authReducer);
    const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
    const route = useParams();
    const shopId = (route as any)?.shopId;
  const navigate = useNavigate();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);
  const [showSearch, setShowSearch] = useState(true);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visible, setVisible] = useState<any>(undefined);
  const [selectedAddOnsForEdit, setSelectedAddOnsForEdit] = useState(undefined);
  const [selectedAddOns, setSelectedAddOns] = useState(undefined);
  const [visiblePopconfirm, setVisiblePopconfirm] = useState(undefined);
  const showPopconfirm = (id: any) => {
    setVisiblePopconfirm(id);
  };
  const [addOnsData, setAddOnsData] = useState<any>({
    loading: false,
    data: null,
  });
  const getAddOns = useCallback(async () => {
    setAddOnsData({ loading: true, data: null });

    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/add-on?type=${type}` +
        (shopId ? `&shopId=${shopId}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setAddOnsData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setAddOnsData({ loading: false, data: [] });
        console.error("AddOns: Error", err);
      });
  }, [shopId]);

  const onStatusChange = async (id: any, val: any) => {
    setConfirmLoading(true);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/add-on`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          shopId: shopId,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Changed Successfully", "success");
            getAddOns();
            setVisible(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  useEffect(() => {
    getAddOns();
  }, [getAddOns]);

  const onClose = () => {
    getAddOns();
    setVisible(undefined);
    setSelectedAddOns(undefined);
    setSelectedAddOnsForEdit(undefined);
  };
  const handleCancel = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setVisiblePopconfirm(undefined);
  };
  return (
    <React.Fragment>

        <div className="content-body_ rounded-2xl">
          <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-0 mb-6">
       
      <BreadCrumb
        title="AddOns List"
        subTitle={`${
          addOnsData?.data?.totalElements ||
          addOnsData?.data?.addOns?.length ||
          0
        } AddOns(s)`}
        extra={[<AddBtn onClick={() => setVisible(true)} key={2} />]}
      />
      <div className={styles.contentWrapper}>
        <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
            <div
              className={
                showSearch ? `content-body-withSearch` : `content-body`
              }
            >
              {addOnsData?.loading ? (
                <Loader />
              ) : (
                <table className={styles.mainTable}>
                  <thead className="bg-white border-b">
                    <tr>
                      <th scope="col">AddOns</th>
                      <th scope="col">TP</th>
                      <th scope="col">MRP</th>
                      <th scope="col">Discounted Price</th>
                      <th scope="col">Status</th>
                      <th scope="col">Created Info</th>
                      <th scope="col">Updated Info</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {addOnsData?.data?.addOns?.length ? (
                      addOnsData?.data?.addOns?.map(
                        (addon: any, index: any) => (
                          <tr
                            className="border-t hover:bg-gray-100"
                            key={index}
                            onClick={() => setSelectedAddOns(addon)}
                          >
                            <td>
                              <Avatar size={40} src={addon?.imageUrl} />{" "}
                              <span className="font-medium text-gray-500 ml-2">
                                {addon?.name}
                              </span>
                            </td>
                            <td>
                              <span className="font-medium text-gray-500 ml-2">
                                {addon?.price?.tp}
                              </span>
                            </td>
                            <td>
                              <span className="font-medium text-gray-500 ml-2">
                                {addon?.price?.mrp}
                              </span>
                            </td>
                            <td>
                              <span className="font-medium text-gray-500 ml-2">
                                {addon?.price?.discountedPrice}
                              </span>
                            </td>
                            <td>
                            <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={addon?.isActive}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onStatusChange(addon?.id, val);
                                  }}
                                  loading={
                                    confirmLoading &&
                                    addon?.id === confirmLoading
                                  }
                                />
                            </td>
                            <td>
                                <small className="font-bold uppercase text-gray-500">
                                  {addon?.createdBy?.name ||
                                    addon?.createdBy?.mobileNumber}{" "}
                                  -{" "}
                                </small>
                                <small
                                  className={`font-capitalize ${
                                    moment().diff(
                                      addon?.createdAt,
                                      "minutes"
                                    ) >= 60
                                      ? "text-red-600"
                                      : "text-gray-800"
                                  }`}
                                >
                                  {moment(addon?.createdAt).fromNow()}
                                </small>
                                <br />
                                <span className="name">
                                  {moment(addon?.createdAt).format("lll")}
                                </span>
                              </td>
                              <td>
                                <small className="font-bold uppercase text-gray-500">
                                  {addon?.updatedBy?.name ||
                                    addon?.updatedBy?.mobileNumber}{" "}
                                  -{" "}
                                </small>
                                <small
                                  className={`font-capitalize ${
                                    moment().diff(
                                      addon?.updatedAt,
                                      "minutes"
                                    ) >= 60
                                      ? "text-red-600"
                                      : "text-gray-800"
                                  }`}
                                >
                                  {moment(addon?.updatedAt).fromNow()}
                                </small>
                                <br />
                                <span className="name">
                                  {moment(addon?.updatedAt).format("lll")}
                                </span>
                              </td>
                            <td>
                              <div className="flex gap-2">
                                <Button
                                  shape="round"
                                  type="dashed"
                                  className="bg-white"
                                  onClick={() =>
                                    setSelectedAddOnsForEdit(addon)
                                  }
                                >
                                  <EditOutlined />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td>
                          <Empty />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

        <Pagination
          {...addOnsData?.data}
          limit={limit}
          page={getPage(loc.search)}
        />
      </div>

      <Drawer
        title={
          visible
            ? "Add AddOns"
            : selectedAddOnsForEdit
            ? "Edit AddOns"
            : "AddOns Details"
        }
        placement="right"
        onClose={onClose}
        open={visible || selectedAddOns || selectedAddOnsForEdit}
        width={450}
      >
        {visible || selectedAddOnsForEdit ? (
          <AddAddOns
            onCloseMethod={onClose}
            visibleData={selectedAddOnsForEdit}
          />
        ) : (
          <SingleAddOns AddOnsDetails={selectedAddOns} />
        )}
      </Drawer>
    
          </div>
        </div>
    
    </React.Fragment>
  ); 
};

ShopAddonsList.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopAddonsList;
